import React, { useMemo, useRef, useState, useEffect } from "react";
import Layout from "../../components/Layout";
import Fuse from "fuse.js";
import { Button, Form, Modal, Table } from "react-bootstrap";
import {
  MdAddCircleOutline,
  MdCheckCircle,
  MdClose,
  MdDelete,
} from "react-icons/md";
import { IoMdCloseCircle } from "react-icons/io";
import { AddressList } from "../Scanner/addressArray";
import { Controller, useForm } from "react-hook-form";
import ReactSelect from "react-select";
import { getEmployeeDetails } from "../../api/EmployeeApi";
import {
  addParcelAddress,
  deleteAllParcelAddress,
  deleteParcelAddressByID,
  getAllParcelAddressbyEmployee,
  getAllParcelAddressbyRoute,
  getAllRoutebyContractor,
} from "../../api/RouteApi";
import ToastFile from "../../utils/ToastFile";
import { useNavigate } from "react-router-dom";
import { useSessionState } from "../../utils/SessionStore";
import "./Parcel.css";
import ButtonLoader from "../../components/ButtonLoader";

const ParcelSorting = () => {
  const [text, setText] = useState("");
  const [listening, setListening] = useState(false);
  const [finalAddressList, setFinalAddressList] = useState([]);
  const [ListOfAddress, setListOfAddress] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [routes, setRoutes] = useState([]);
  const fetched = useRef(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const [parcelAddress, setParcelAddress] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [addressOption, setAddressOption] = useState([]);
  const [isLoading, setIsloading] = useState(false);
  const navigate = useNavigate();
  const [showSelectRoute, setShowSelectRoute] = useState(null);
  const [isSorted, setIsSorted] = useState(false);
  const [isBigChecked, setIsBigChecked] = useState(false);

  useEffect(() => {
    if (fetched.current) return;
    fetched.current = true;
    getRoute();
    getParcelAddress();
    if (
      !(
        localStorage.getItem("RouteForAddress") === "" ||
        localStorage.getItem("RouteForAddress") === null
      )
    ) {
      let RouteForAddress = JSON.parse(localStorage.getItem("RouteForAddress"));
      setShowSelectRoute(
        finalAddressList.length > 0 ? RouteForAddress.label : null
      );
      //onSubmit(RouteForAddress, true);
    }
  }, []);

  const getRoute = async () => {
    await Promise.all([
      getEmployeeDetails(user.id),
      getAllRoutebyContractor(user.tenant_id),
    ])
      .then(([employeeRes, routesRes]) => {
        if (employeeRes.status === 200 && routesRes.status === 200) {
          const employee = employeeRes?.data?.data;
          if (employee?.parcelSortRoutesList && employee?.parcelSortRoutesList.length > 0) {
            const options = routesRes?.data?.data?.routes
              .filter((route) => employee.parcelSortRoutesList.includes(route._id))
              .map((route) => ({
                value: route.route_id,
                label: route.routeName,
              }));
            setRoutes(options);
          } else{
            ToastFile("You have no access to any routes. Please contact your contractor.", "info");
          }
        } else {
          ToastFile("Failed to fetch employee details", "error");
        }
      })
      .catch((err) => {
        console.error("Error fetching employee details:", err);
        ToastFile("Error fetching employee details", "error");
      });
  };

  const SpeechRecognition =
    window.SpeechRecognition || window.webkitSpeechRecognition;
  const recognition = new SpeechRecognition();
  recognition.continuous = false;
  recognition.interimResults = false;
  recognition.lang = "en-IN";

  const fuse = useMemo(() => {
    return new Fuse(ListOfAddress, {
      includeScore: true,
      threshold: 0.4,
      shouldSort: true,
      ignoreLocation: true,
      distance: 100,
    });
  }, [ListOfAddress]);

  const numberWordsToDigits = (text) => {
    const numberMap = {
      zero: "0",
      one: "1",
      two: "2",
      three: "3",
      four: "4",
      five: "5",
      six: "6",
      seven: "7",
      eight: "8",
      nine: "9",
      ten: "10",
      eleven: "11",
      twelve: "12",
      thirteen: "13",
      fourteen: "14",
      fifteen: "15",
      sixteen: "16",
      seventeen: "17",
      eighteen: "18",
      nineteen: "19",
      twenty: "20",
      thirty: "30",
      forty: "40",
      fifty: "50",
      sixty: "60",
      seventy: "70",
      eighty: "80",
      ninety: "90",
    };

    const tokens = text.toLowerCase().split(" ");
    const convertedTokens = [];

    let i = 0;
    while (i < tokens.length) {
      const word = tokens[i];
      const next = tokens[i + 1] || "";

      // Try two-word combinations (like "twenty one")
      if (numberMap[word] && numberMap[next]) {
        const val = parseInt(numberMap[word]) + parseInt(numberMap[next]);
        convertedTokens.push(val.toString());
        i += 2;
      } else if (numberMap[word]) {
        convertedTokens.push(numberMap[word]);
        i += 1;
      } else {
        convertedTokens.push(word);
        i += 1;
      }
    }

    return convertedTokens.join(" ");
  };

  const normalize = (s) =>
    numberWordsToDigits(
      s
        ?.toLowerCase()
        .replace(/[^\p{L}\p{N}\s]/gu, "")
        .replace(/\s+/g, " ")
        .trim()
    );

  const matchAddress = (line) => {
    const normalizedLine = normalize(line);
    const normalizedList = ListOfAddress.map(normalize);

    const idx = normalizedList.indexOf(normalizedLine);
    if (idx !== -1) {
      return { type: "exact", match: ListOfAddress[idx] };
    }

    const results = fuse.search(normalizedLine);
    const fuzzyMatches = results
      .filter((r) => r.score !== undefined && r.score <= 0.5)
      .slice(0, 5)
      .map((r) => r.item);

    let extendedSuggestions = [...fuzzyMatches];

    if (fuzzyMatches.length > 0) {
      const firstMatch = fuzzyMatches[0];
      const streetName = firstMatch
        .replace(/^\d+\s*/, "")
        .trim()
        .toLowerCase();

      const additionalMatches = ListOfAddress.filter((addr) => {
        const addrStreet = addr
          .replace(/^\d+\s*/, "")
          .trim()
          .toLowerCase();
        return (
          addrStreet === streetName &&
          addr !== firstMatch &&
          !fuzzyMatches.includes(addr)
        );
      });

      extendedSuggestions = [...fuzzyMatches, ...additionalMatches];
    }

    return {
      type: "fuzzy",
      candidates: extendedSuggestions,
    };
  };

  const startListening = () => {
    setListening(true);
    recognition.start();

    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      setText(transcript);
      const result = matchAddress(transcript);
      if (result.type === "exact") {
        setSuggestions([result.match]);
      } else if (result.type === "fuzzy" && result.candidates.length > 0) {
        setSuggestions(result.candidates);
      }
      setShowSuggestions(true);
      setListening(false);
    };

    recognition.onerror = (event) => {
      console.error("Speech recognition error:", event.error);
      setListening(false);
    };

    recognition.onend = () => {
      setListening(false);
    };
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setText(value);
    const result = matchAddress(value);
    if (result.type === "exact") {
      setSuggestions([result.match]);
    } else if (result.type === "fuzzy" && result.candidates.length > 0) {
      setSuggestions(result.candidates);
    }
    setShowSuggestions(true);
  };

  const handleSuggestionClick = (suggestion) => {
    setFinalAddressList((prev) => [...prev, suggestion]);
    setText("");
    setSuggestions([]);
    setShowSuggestions(false);
  };

  const finishAndSort = () => {
    const sorted = [...finalAddressList].sort(
      (a, b) =>
        ListOfAddress.indexOf(a.address) - ListOfAddress.indexOf(b.address)
    );
    setFinalAddressList(
      sorted.map((item, index) => ({ ...item, s_number: index + 1 }))
    );
    setIsSorted(true);
    ToastFile("Address sorted successfully", "success");
  };

  const deleteAddress = (indexToRemove) => {
    deleteParcelAddressByID(finalAddressList[indexToRemove]._id)
      .then((res) => {
        if (res.status === 200) {
          const newArr = finalAddressList.filter(
            (_, index) => index !== indexToRemove
          );
          setFinalAddressList(newArr);
        }
      })
      .catch((err) => {
        ToastFile("Error deleting address", "error");
      });
  };

  const {
    register,
    control,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
  } = useForm();

  const onSubmit = (data, otherData) => {
    if(!data?.selectedRoute){
      ToastFile("Please select any route","info");
      return;
    }
    setIsloading(true);
    const isFromLoad = typeof otherData === "boolean" ? true : false;
    getAllParcelAddressbyRoute(
      isFromLoad ? data?.value : data?.selectedRoute?.value,
      user.role === "employee" ? true : false
    )
      .then((res) => {
        if (res.status === 200) {
          setParcelAddress(res?.data?.data?.addresses);
          const options = res?.data?.data?.addresses.map((parcel) => ({
            value: parcel._id,
            label: parcel.address,
          }));
          setAddressOption(options);
          const addressList = res?.data?.data?.addresses.map(
            (el) => el.address
          );
          setListOfAddress(addressList);
          if (isFromLoad) {
            setShowSelectRoute(data?.label);
            localStorage.setItem("RouteForAddress", JSON.stringify(data));
          } else {
            setShowSelectRoute(data?.selectedRoute.label);
            localStorage.setItem(
              "RouteForAddress",
              JSON.stringify(data?.selectedRoute)
            );
          }
        } else {
          ToastFile("Failed to fetch address", "error");
        }
      })
      .catch((err) => {
        console.error("Error fetching address:", err);
        ToastFile("Error fetching address", "error");
      })
      .finally(() => {
        setIsloading(false);
      });
  };

  const PrintAddress = () => {
    navigate("/printAddress", { state: { finalAddressList } });
  };

  const removeRoute = () => {
    setShowSelectRoute(null);
    setParcelAddress([]);
    setAddressOption([]);
    setListOfAddress([]);
    localStorage.setItem("RouteForAddress", "");
    removeAllAddress()
  };

  const handleBigCheckboxChange = (event) => {
    const checked = event.target.checked;
    setIsBigChecked(checked);
  };

  const handleAddAddress = async () => {
    if (selectedAddress) {
      let addressM = parcelAddress.find(
        (el) => el._id === selectedAddress.value
      );
      let payload = {
        address: addressM.address,
        streetName: addressM.streetName,
        isBig: isBigChecked,
        employee_id: user?.user_id,
        tenant_id: user?.tenant_id,
        createdBy: user?.user_id,
        createdAt: new Date(),
        modifiedBy: user?.user_id,
        modifiedAt: new Date(),
      };
      await addParcelAddress(payload)
        .then((res) => {
            setFinalAddressList((prev) => [
              ...prev,
              { ...payload, isBig: isBigChecked },
            ]);
        })
        .catch(() => {
          ToastFile("Failed to add", "error");
        })
        .finally(() => {
          setValue("searchAddress", null);
          setSelectedAddress(null);
          setIsBigChecked(false);
        });
    } else {
      ToastFile("Please select address");
    }
  };

  const removeAllAddress = async () => {
    let payload = {
      employee_id: user.user_id,
    };
    await deleteAllParcelAddress(payload)
      .then((res) => {
        if (res.status === 200) {
          setFinalAddressList([]);
        }
      })
      .catch(() => {
        ToastFile("Failed to delete all", "error");
      });
  };

  const getParcelAddress = async () => {
    await getAllParcelAddressbyEmployee(user?.user_id)
      .then((addressRes) => {
        if (addressRes.status === 200) {
          setFinalAddressList(addressRes.data.data.addresses);
        }
      })
      .catch((err) => {
        console.error("Error fetching employee details:", err);
      });
  };

  return (
    <Layout>
      {/* Suggestions */}
      {/* <Modal
        show={showSuggestions}
        onHide={() => setShowSuggestions(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Did you mean?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {suggestions.length === 0 ? (
            <p>No close matches found.</p>
          ) : (
            <div className="d-grid gap-2">
              {suggestions.map((s, i) => (
                <Button
                  key={i}
                  variant="outline-primary"
                  onClick={() => handleSuggestionClick(s)}
                >
                  {s}
                </Button>
              ))}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowSuggestions(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal> */}
      <div className="d-flex justify-content-between align-items-center mb-3 w-100">
        <div className="d-flex justify-content-start align-items-center">
           <span
            style={{
              fontSize: "22px",
              fontWeight: 600,
              minWidth: "140px",
            }}
          >
          {showSelectRoute
              ? `Parcel Sorting (${showSelectRoute})`
              : "Parcel Sorting"}
          </span>
          {showSelectRoute && (
            <button
      className="btn btn-sm btn-outline-secondary rounded-pill d-flex align-items-center gap-1"
      onClick={removeRoute}
      title="Clear selection"
    >
      <IoMdCloseCircle size={16} />
      <span>Clear</span>
    </button>
          )}
        </div>
        
      </div>
      {!showSelectRoute ? (
        <Form
          onSubmit={handleSubmit(onSubmit)}
          className="d-flex align-items-center gap-3 flex-wrap"
        >
          <Form.Group className="d-flex align-items-center gap-2 mb-0">
            <Form.Label className="mb-0">Select Route</Form.Label>
            <div style={{ width: "300px" }}>
              <Controller
                control={control}
                name="selectedRoute"
                rules={{ required: false }}
                render={({ field }) => (
                  <ReactSelect
                    {...field}
                    // isMulti
                    className="py-1 rounded-0"
                    options={routes}
                    onChange={(selected) => {
                      field.onChange(selected); // update form value
                    }}
                  />
                )}
              />
            </div>
          </Form.Group>
          <Button variant="primary" type="submit" style={{minWidth:'98px'}}>
            {isLoading ? <ButtonLoader width="20px" height="20px"/> : "Start"}
          </Button>
        </Form>
      ) : (
        <div className="p-4" style={{ maxWidth: "600px", margin: "0 auto" }}>
          <Form className="d-flex align-items-center gap-2 flex-wrap">
            <Form.Group className="d-flex align-items-center gap-2 mb-0 flex-grow-1 flex-shrink-1">
              <Form.Label className="responsive-select-label mb-0">
                Search Address
              </Form.Label>
              <div className="responsive-select-container">
                <Controller
                  control={control}
                  name="searchAddress"
                  rules={{ required: false }}
                  render={({ field }) => (
                    <ReactSelect
                      {...field}
                      // isMulti
                      className="py-1 rounded-0"
                      options={addressOption}
                      onChange={(selected) => {
                        field.onChange(selected);
                        setSelectedAddress(selected);
                        setIsSorted(false);
                      }}
                    />
                  )}
                />
              </div>
            </Form.Group>
            <Form.Group className="d-flex align-items-center gap-1 mb-0">
              <input
                type="checkbox"
                checked={isBigChecked}
                onChange={handleBigCheckboxChange}
                size={30}
              />
              <label className="px-1">Big parcel</label>
            </Form.Group>
            <Form.Group className="mb-0">
              <Button
                variant="outline-success"
                className=""
                onClick={handleAddAddress}
              >
                Add
              </Button>
            </Form.Group>
          </Form>

          {/* <Button
          className="mb-3 w-100"
          onClick={startListening}
          disabled={listening}
        >
          {listening ? "🎙 Listening..." : "🎤 Start Voice Input"}
        </Button> */}

          {/* <Form.Control
          as="textarea"
          rows={3}
          placeholder="Speak or type address..."
          value={text}
          onChange={handleInputChange}
        /> */}

          {finalAddressList.length > 0 && (
            <>
              <div className="d-flex justify-content-between align-items-center">
                <h5 className="mt-4">Selected Addresses</h5>
                <div className="d-flex align-items-center gap-2 mt-3">
                  <div className="d-flex align-items-center gap-2 justify-content-end">
                    {isSorted ? (
                      <Button
                        variant="outline-success"
                        className=""
                        onClick={PrintAddress}
                      >
                        Print PDF
                      </Button>
                    ) : (
                      <Button
                        variant="outline-success"
                        className=""
                        onClick={finishAndSort}
                      >
                        Finish & Sort Address
                      </Button>
                    )}
                  </div>
                  <Button
                    variant="danger"
                    type="button"
                    //className="p-1 py-0"
                    //style={{ height: 30 }}
                    onClick={() => removeAllAddress()}
                  >
                    {"remove all"}
                  </Button>
                </div>
              </div>
              <Table striped bordered hover className="table-sm mt-2">
                <thead className="table-dark">
                  <tr>
                    <th>#</th>
                    <th>Address</th>
                    <th>Size</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {finalAddressList.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.address}</td>
                      <td>{item.isBig ? "Big" : ""}</td>
                      <td>
                        <button
                          className="btn btn-sm btn-outline-danger border-0"
                          onClick={() => deleteAddress(index)}
                          title="Delete"
                        >
                          <MdDelete size={16} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </>
          )}
        </div>
      )}
    </Layout>
  );
};

export default ParcelSorting;
